/* ==========================================================================
   Custom build form
   1. Shows the gaming-only questions when the primary use involves gaming.
   2. Prefills the form from the build finder answers passed in the URL
      (games / res / hz / settings / budget), then tells the customer so.
   ========================================================================== */
(function () {
  'use strict';

  function titleize(str) {
    return String(str || '')
      .split('-')
      .filter(Boolean)
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }

  /* pick the <option> whose text contains every needle */
  function selectMatch(select, needles) {
    if (!select) return false;
    var list = [].slice.call(select.options);
    for (var i = 0; i < list.length; i++) {
      var text = list[i].textContent.toLowerCase();
      var ok = needles.every(function (n) { return text.indexOf(n.toLowerCase()) > -1; });
      if (ok) {
        select.value = list[i].value || list[i].textContent;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function init(form) {
    if (!form || form.dataset.cbReady === '1') return;
    form.dataset.cbReady = '1';

    var use = form.querySelector('[data-cb-use]');
    var gaming = form.querySelector('[data-cb-gaming]');
    var notice = form.querySelector('[data-cb-prefill-notice]');

    function syncGaming() {
      if (!gaming || !use) return;
      var v = (use.value || '').toLowerCase();
      var isGaming = v.indexOf('gaming') > -1 || v === '';
      gaming.style.display = isGaming ? '' : 'none';
    }
    if (use) use.addEventListener('change', syncGaming);
    syncGaming();

    /* ---------- prefill from the build finder ---------- */
    var params = new URLSearchParams(window.location.search);
    if (!params.toString()) return;
    var filled = false;

    var games = params.get('games');
    var gamesField = form.querySelector('[data-cb-games]');
    if (games && gamesField && !gamesField.value) {
      gamesField.value = games.split(',').map(titleize).join(', ');
      filled = true;
    }

    var res = params.get('res');
    if (res) {
      var resMap = { '1080p': ['1080p'], '1440p': ['1440p'], '4k': ['4k'] };
      if (selectMatch(form.querySelector('[data-cb-resolution]'), resMap[res.toLowerCase()] || [res])) filled = true;
    }

    var hz = params.get('hz');
    if (hz) {
      var hzMap = { '60hz': ['60'], '144hz': ['144'], '240hz': ['240'], '360hz': ['360'] };
      if (selectMatch(form.querySelector('[data-cb-refresh]'), hzMap[hz.toLowerCase()] || [hz])) filled = true;
    }

    var settings = params.get('settings');
    if (settings) {
      var setMap = { performance: ['performance'], high: ['high settings'], ultra: ['max'] };
      if (selectMatch(form.querySelector('[data-cb-settings]'), setMap[settings.toLowerCase()] || [settings])) filled = true;
    }

    var budget = params.get('budget');
    if (budget) {
      var budgetMap = {
        'under-1000': ['1,000'],
        '1000-1500': ['1,500'],
        '1500-2500': ['2,500'],
        '2500-plus': ['3,500'],
        unsure: ['not sure']
      };
      if (selectMatch(form.querySelector('[data-cb-budget]'), budgetMap[budget.toLowerCase()] || [budget])) filled = true;
    }

    if (filled) {
      if (use && (games || res || hz || settings)) {
        selectMatch(use, ['gaming']);
        syncGaming();
      }
      if (notice) notice.hidden = false;
    }
  }

  function initAll(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-custom-build-form]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
